import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useCountryFromUrl } from '@cbgms/base/hooks'
import { storeOnboardingWholesalerCredentials, storeWholesalerCredentials } from 'app/accounts/state/wholesaler/actions'
import { Credentials } from '@cbgms/api'

export const useStoreOnboardingWholesalerCredentials = () => {
  const dispatch = useDispatch()
  const { isNetherlands } = useCountryFromUrl()

  return useCallback(
    async (credentials: Credentials, wholesalerUUID: string, ticketUUID: string | null) => {
      const response = await dispatch(
        isNetherlands && ticketUUID
          ? storeOnboardingWholesalerCredentials({
              Credentials: credentials,
              TicketUUID: ticketUUID
            })
          : storeWholesalerCredentials({
              WholesalerUUID: wholesalerUUID,
              Credentials: credentials
            })
      )

      return response
    },
    [dispatch, isNetherlands]
  )
}
